"use strict";

var _regeneratorRuntime = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/regenerator/index.js");

var _toConsumableArray = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _asyncToGenerator = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var get_image_objects_1 = require("./get-image-objects");

var DEFAULT_GATSBY_IMAGE_MAX_WIDTH = 1080;

var getGatsbyImageData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$base64Transforma, base64Transformations, _ref$base64Width, base64Width, _ref$breakpoints, breakpoints, _ref$chained, chained, _ref$maxWidth, maxWidth, origin, path, _ref$transformations, transformations, _ref$version, version, max, sizes, _yield, base64, src, aspectRatio, cleaned, deduped, srcSet;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$base64Transforma = _ref.base64Transformations, base64Transformations = _ref$base64Transforma === void 0 ? [] : _ref$base64Transforma, _ref$base64Width = _ref.base64Width, base64Width = _ref$base64Width === void 0 ? get_image_objects_1.DEFAULT_BASE64_WIDTH : _ref$base64Width, _ref$breakpoints = _ref.breakpoints, breakpoints = _ref$breakpoints === void 0 ? [200, 400, 600] : _ref$breakpoints, _ref$chained = _ref.chained, chained = _ref$chained === void 0 ? [] : _ref$chained, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? DEFAULT_GATSBY_IMAGE_MAX_WIDTH : _ref$maxWidth, origin = _ref.origin, path = _ref.path, _ref$transformations = _ref.transformations, transformations = _ref$transformations === void 0 ? [] : _ref$transformations, _ref$version = _ref.version, version = _ref$version === void 0 ? false : _ref$version;
            max = maxWidth !== null && maxWidth !== void 0 ? maxWidth : DEFAULT_GATSBY_IMAGE_MAX_WIDTH;
            sizes = "(max-width: ".concat(max, "px) 100vw, ").concat(max, "px");
            _context.next = 5;
            return (0, get_image_objects_1.getSharedImageData)({
              base64Transformations: base64Transformations,
              base64Width: base64Width,
              breakpoints: breakpoints,
              chained: chained,
              origin: origin,
              path: path,
              transformations: transformations,
              version: version
            });

          case 5:
            _yield = _context.sent;
            base64 = _yield.base64;
            src = _yield.src;
            aspectRatio = (0, get_image_objects_1.getAspectRatio)(transformations, 1);
            cleaned = breakpoints.concat(max).filter(function (w) {
              return w <= max;
            }).sort(function (a, b) {
              return a - b;
            });
            deduped = _toConsumableArray(Array.from(new Set(cleaned)));
            srcSet = deduped.map(function (breakpointWidth) {
              var url = (0, get_image_objects_1.getImageURL)({
                chained: chained,
                origin: origin,
                path: path,
                version: version,
                transformations: transformations.concat("w_".concat(breakpointWidth))
              });
              return "".concat(url, " ").concat(breakpointWidth, "w");
            }).join();
            return _context.abrupt("return", {
              backgroundColor: '#ffffff',
              height: max / aspectRatio,
              images: {
                fallback: {
                  sizes: sizes,
                  src: src,
                  srcSet: srcSet
                },
                sources: []
              },
              layout: 'constrained',
              placeholder: {
                fallback: base64
              },
              width: max
            });

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getGatsbyImageData(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.default = getGatsbyImageData;